export class BusinessType {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
    MinimumOrderQuantityFeeCode: string;
    AppliesToSoldTo: boolean;
    BusinessTypeExtension: string;
}

export default BusinessType;